import { Select, SelectProps } from 'antd';
import { CustomerStateEnum } from '../api';
import { DefaultOptionType } from 'antd/es/select';
import { useMemo } from 'react';
import { CustomerStateText } from './CustomerState';

const stateOptions: DefaultOptionType[] = [
  // {
  //   label: '未知',
  //   value: CustomerStateEnum.UNKNOWN,
  // },
  {
    label: <CustomerStateText state={CustomerStateEnum.WAIT_FOLLOW_UP} />,
    value: CustomerStateEnum.WAIT_FOLLOW_UP,
  },
  {
    label: <CustomerStateText state={CustomerStateEnum.UNQUALIFIED} />,
    value: CustomerStateEnum.UNQUALIFIED,
  },
  {
    label: <CustomerStateText state={CustomerStateEnum.WAIT_SIGN} />,
    value: CustomerStateEnum.WAIT_SIGN,
  },
  {
    label: <CustomerStateText state={CustomerStateEnum.VISITED} />,
    value: CustomerStateEnum.VISITED,
  },
  {
    label: <CustomerStateText state={CustomerStateEnum.SIGNED} />,
    value: CustomerStateEnum.SIGNED,
  },
  // {
  //   label: '审核中',
  //   value: CustomerStateEnum.APPROVAL,
  // },
  {
    label: <CustomerStateText state={CustomerStateEnum.LOAN} />,
    value: CustomerStateEnum.LOAN,
  },
  // {
  //   label: '在审件',
  //   value: CustomerStateEnum.EXAMINING,
  // },
  {
    label: <CustomerStateText state={CustomerStateEnum.INVALID} />,
    value: CustomerStateEnum.INVALID,
  },
];

export default (
  props: SelectProps & {
    enableState?: CustomerStateEnum[];
    disableState?: CustomerStateEnum[];
  },
) => {
  const options = useMemo(() => {
    if (!props.enableState?.length) {
      return stateOptions;
    }
    return stateOptions.filter((option) =>
      props.enableState?.includes(option.value as CustomerStateEnum),
    );
  }, [props.enableState]);
  return (
    <Select
      {...props}
      options={options
        .filter((item) => item.value !== CustomerStateEnum.APPROVAL)
        .map((item) => {
          return {
            ...item,
            disabled: props.disableState?.includes(
              item.value as CustomerStateEnum,
            ),
          };
        })}
      placeholder="客户状态"
      style={{ width: '140px', ...props.style }}
    />
  );
};
